module.exports = __webpack_public_path__ + "static/img/tk-activity-bg.0317ab9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tk-activity-bg.jpeg
// module id = Cs0w
// module chunks = 0